import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import { useOrder } from '../context/OrderContext';

interface CartIconProps {
    className?: string;
    light?: boolean;
}

const CartIcon: React.FC<CartIconProps> = ({ className = "", light = false }) => {
    const { setIsCartOpen } = useContext(AppContext);
    const { totalItems } = useOrder();

    return (
        <button
            onClick={() => setIsCartOpen(true)}
            className={`relative p-2 rounded-full transition-all active:scale-95 ${className} ${light ? 'bg-white/20 hover:bg-white/30 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                }`}
            aria-label="Voir le panier"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                />
            </svg>

            {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white ring-2 ring-white animate-bounce-in">
                    {totalItems > 99 ? '99+' : totalItems}
                </span>
            )}
        </button>
    );
};

export default CartIcon;
